<div *ngIf="hasAcces" xmlns="http://www.w3.org/1999/html">
  <div class="widget-navigation">
    <a href="#information" class="scrollTo transition">Information </a>
    <a href="#status" class="scrollTo transition">Status </a>
    <a href="#security" class="scrollTo transition">Security </a>
    <a href="#getRoamingPartners" class="scrollTo transition"
      >Roaming Partners
    </a>
    <a href="#getServingJsServers" class="scrollTo transition">Serving JSs </a>
    <!--<a href="#alarms" -->
    <!--class="scrollTo transition">Alarms-->
    <!--</a>-->
    <a href="#getNetworkServerLogs" class="scrollTo transition">Logs </a>
  </div>

  <form id="information" #validate="ngForm">
    <div class="widget-title margin-top-42"></div>
    <div class="widget width-49-perc margin-right-2-perc">
      <div class="widget-title">Network Server Info</div>
      <div class="info-content hide">
        <div class="widget-inner-title hide">VirtID:</div>
        <div class="widget-inner-content hide virtId">
          <input id="virtId" [value]="listInfo['virtId']" [disabled]="true" />
        </div>
      </div>

      <!--Protocol Version area-->
      <div class="info-content first-row">
        <div class="widget-inner-title">
          Protocol Version:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['protocolVersion'] }}"
            [disabled]="true"
          />

          <app-protocol-edit
            *ngIf="isAdmin"
            (onChange)="toggleRenderNsID($event)"
            virtId="{{ listInfo['virtId'] }}"
            saveType="NN"
            inputValue="{{ listInfo['protocolVersion'] }}"
          >
          </app-protocol-edit>
        </div>
      </div>

      <!--NetID field -->
      <div class="info-content">
        <div class="widget-inner-title">
          NetID:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin || renderNsGroup"
            value="{{ listInfo['netIds'] | cidr }}"
            [disabled]="true"
          />
          <app-input-dynamic-list
            *ngIf="isAdmin && !renderNsGroup"
            validationType="netId"
            virtId="{{ listInfo['virtId'] }}"
            protocolVersion="{{ listInfo['protocolVersion'] }}"
            [inputValueSetter]="listInfo['netIds']"
            (onRemovedNetIDs)="toggleRenderNsGroup()"
          >
          </app-input-dynamic-list>
        </div>
      </div>
      <div class="info-content">
        <div class="widget-inner-title">
          Name:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['name'] }}"
            [disabled]="true"
          />

          <app-input-edit
            *ngIf="isAdmin"
            validationType="name"
            formType="NS"
            saveType="name"
            virtId="{{ listInfo['virtId'] }}"
            inputValue="{{ listInfo['name'] }}"
          >
          </app-input-edit>
        </div>
      </div>
      <div class="info-content">
        <div class="widget-inner-title">
          fNS URL:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['url_fns'] }}"
            [disabled]="true"
          />

          <app-input-edit
            *ngIf="isAdmin"
            validationType="url"
            fns_url="{{ listInfo['url_fns'] }}"
            sns_url="{{ listInfo['url_sns'] }}"
            hns_url="{{ listInfo['url_hns'] }}"
            saveType="url_fns"
            virtId="{{ listInfo['virtId'] }}"
            inputValue="{{ listInfo['url_fns'] }}"
          >
          </app-input-edit>
        </div>
      </div>
      <div class="info-content">
        <div class="widget-inner-title">
          sNS URL:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['url_sns'] }}"
            [disabled]="true"
          />

          <app-input-edit
            *ngIf="isAdmin"
            validationType="url"
            saveType="url_sns"
            fns_url="{{ listInfo['url_fns'] }}"
            sns_url="{{ listInfo['url_sns'] }}"
            hns_url="{{ listInfo['url_hns'] }}"
            virtId="{{ listInfo['virtId'] }}"
            inputValue="{{ listInfo['url_sns'] }}"
          >
          </app-input-edit>
        </div>
      </div>
      <div class="info-content">
        <div class="widget-inner-title">
          hNS URL:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['url_hns'] }}"
            [disabled]="true"
          />

          <app-input-edit
            *ngIf="isAdmin"
            validationType="url"
            saveType="url_hns"
            virtId="{{ listInfo['virtId'] }}"
            fns_url="{{ listInfo['url_fns'] }}"
            sns_url="{{ listInfo['url_sns'] }}"
            hns_url="{{ listInfo['url_hns'] }}"
            inputValue="{{ listInfo['url_hns'] }}"
          >
          </app-input-edit>
        </div>
      </div>

      <!--PrimaryHub area-->
      <div class="info-content">
        <div class="widget-inner-title">
          Platform:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['platformId'] }}"
            [disabled]="true"
          />

          <app-select-edit
            *ngIf="isAdmin"
            validationType="platform"
            virtId="{{ listInfo['virtId'] }}"
            inputValue="{{ listInfo['platformId'] }}"
          >
          </app-select-edit>
        </div>
      </div>

      <!--Ns Group area-->
      <div class="info-content" *ngIf="renderNsGroup">
        <div class="widget-inner-title">
          NS Group / Subnet ID:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['nsGroupId'] }} - {{ listInfo['subnwkId'] }}"
            [disabled]="true"
          />

          <app-select-ns-group
            *ngIf="renderNsGroup && isAdmin"
            virtId="{{ listInfo['virtId'] }}"
            inputValue="{{ listInfo['nsGroupId'] }}"
            inputSubnetworkId="{{ listInfo['subnwkId'] }}"
            inputNetId="{{ listInfo['netIds'] | cidr }}"
            (onSave)="refreshNetworkServer()"
            (onNsGroupRemoved)="nsGroupRemoved()"
          >
          </app-select-ns-group>
        </div>
      </div>

      <!-- NS ID area-->
      <div class="info-content" *ngIf="renderNsID">
        <div class="widget-inner-title">
          NS ID:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['nsId'] }}"
            [disabled]="true"
          />

          <app-input-edit
            *ngIf="isAdmin"
            validationType="nsId"
            formType="NS"
            saveType="nsId"
            virtId="{{ listInfo['virtId'] }}"
            inputValue="{{ listInfo['nsId'] }}"
          >
          </app-input-edit>
        </div>
      </div>

      <!-- Subscriber ID area-->
      <div class="info-content" *ngIf="renderNsID">
        <div class="widget-inner-title">
          Subscriber ID:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input
            *ngIf="!isAdmin"
            value="{{ listInfo['subscriberId'] }}"
            [disabled]="true"
          />

          <app-input-edit
            *ngIf="isAdmin"
            validationType="subscriberId"
            formType="NS"
            saveType="subscriberId"
            virtId="{{ listInfo['virtId'] }}"
            inputValue="{{ listInfo['subscriberId'] }}"
          >
          </app-input-edit>
        </div>
      </div>

      <!--Alarm threshold area-->
      <!--<div class="info-content"-->
      <!--[ngClass]="{'last-row-user': !isAdmin}">-->
      <!--<div class="widget-inner-title">Alarm threshold:-->
      <!--<i class="fa fa-info-circle info-text"></i>-->
      <!--</div>-->

      <!--<div class="widget-inner-content">-->

      <!--<input *ngIf="!isAdmin"-->
      <!--value="{{listInfo['messageTrafficThreshold']}}"-->
      <!--[disabled]="true"/>-->

      <!--<app-input-edit *ngIf="isAdmin"-->
      <!--validationType="alarm"-->
      <!--saveType="alarm"-->
      <!--virtId="{{listInfo['virtId']}}"-->
      <!--inputValue="{{listInfo['messageTrafficThreshold']}}">-->
      <!--</app-input-edit>-->
      <!--</div>-->
      <!--</div>-->
      <div *ngIf="isAdmin" class="info-content last-row">
        <div class="widget-inner-title">
          Owner/Affiliation:
          <i class="fa fa-info-circle info-text"></i>
        </div>

        <div *ngIf="isAdmin" class="widget-inner-content">
          <app-edit-popover-button
            inputValue="{{ strOwnership }}"
            ownerUname="{{ listInfo['username'] }}"
            ownerFname="{{ ownerFname }}"
            ownerLname="{{ ownerLname }}"
            ownerEmail="{{ ownerEmail }}"
            ownerAffiliation="{{ ownerAffiliation }}"
            virtId="{{ listInfo['virtId'] }}"
          >
          </app-edit-popover-button>
        </div>
      </div>

      <div class="btn-area" [ngClass]="{ 'margin-top': !isAdmin }">
        <button
          class="btn btn-outline-success my-2 my-sm-0 transition"
          [ngClass]="{ isDisabled: !isAdmin }"
          [disabled]="!isAdmin"
          (click)="deleteModal.show()"
        >
          Delete
        </button>

        <app-delete-modal
          #deleteModal
          text="Network server {{ listInfo['name'] }} will be deleted."
          server="{{ listInfo['virtId'] }}"
          deleteType="networkServerDetail"
        >
        </app-delete-modal>
      </div>
    </div>

    <div>
      <div id="status" class="widget width-49-perc">
        <div class="widget-title">
          Status
          <i
            class="text-tooltip"
            [ngClass]="(statusRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'"
            aria-hidden="true"
            title-popup="Refresh"
            (click)="refreshNsStatus()"
          >
          </i>
        </div>
        <div class="info-content">
          <div class="widget-inner-title first-row">
            Status:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">
            <input value="{{ listStatus['status'] }}" [disabled]="true" />
          </div>
        </div>
        <div class="info-content last-row">
          <div class="widget-inner-title">
            Message Count:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">
            <input
              value="{{ listStatus['messageCount'] }} {{
                listStatus['hasError'] ? '(!)' : ''
              }}"
              [disabled]="true"
            />
          </div>
        </div>
      </div>

      <div id="security" class="widget width-49-perc margin-top-42">
        <div class="widget-title">Security</div>

        <!--Security area-->
        <div class="info-content first-row">
          <div class="widget-inner-title">
            Transport Security:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">
            <input
              *ngIf="!isAdmin"
              value="{{ listInfo['security'] }}"
              [disabled]="true"
            />

            <app-security-edit
              *ngIf="isAdmin"
              virtId="{{ listInfo['virtId'] }}"
              inputValue="{{ listInfo['security'] }}"
            >
            </app-security-edit>
          </div>
        </div>

        <!--Auth area-->
        <div class="info-content">
          <app-authtype-edit
            *ngIf="isAdmin"
            virtId="{{ listInfo['virtId'] }}"
            inputAuthType="{{ listInfo['authType'] }}"
            inputAuthUsername="{{ listInfo['authUsername'] }}"
            inputAuthPassword="{{ listInfo['authPassword'] }}"
          >
          </app-authtype-edit>
        </div>
      </div>

      <div id="helium" class="widget width-49-perc margin-top-42">
        <!-- Additional Accounting Area -->
        <div class="info-content last-row">
          <div class="widget-inner-title">
            Additional Accounting:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">
            <input
              type="checkbox"
              *ngIf="!isAdmin"
              [checked]="listInfo['heliumMember']"
              [disabled]="true">

            <app-input-checkbox
              *ngIf="isAdmin"
              validationType="heliumMember"
              saveType="heliumMember"
              label="Helium-Style"
              virtId="{{ listInfo['virtId'] }}"
              [inputValue]="listInfo['heliumMember']">
            </app-input-checkbox>
          </div>
        </div>
      </div>

      <div id="nsgroup" class="widget width-49-perc margin-top-42" *ngIf="isAdmin && isNsGroupMember(listInfo)">
        <div class="widget-title">Network Server Group</div>
        <div class="info-content first-row">
          <span style="margin-left: 10%;"><a [routerLink]="['/network-group',listInfo.nsGroupId]">Go to NS Group</a></span>
        </div>
      </div>
    </div>
  </form>


  <!-- Roaming Partners -->
  <app-roaming-partners
    virtId="{{ listInfo['virtId'] }}"
    [netIds]="listInfo['netIds']"
    name="{{ listInfo['name'] }}"
    [renderNsGroup]="renderNsGroup"
    (roamingPartnersLoadedEvent)="roamingPartnersLoaded($event)"
  ></app-roaming-partners>

  <!-- Activation Agreements -->
  <app-serving-join-servers
    virtId="{{ listInfo['virtId'] }}"
    [netIds]="listInfo['netIds']"
    name="{{ listInfo['name'] }}"
    protocolVersion="{{ listInfo['protocolVersion'] }}"
    [renderNsGroup]="renderNsGroup"
    (servingJoinServersLoadedEvent)="servingJoinServersLoaded($event)"
  ></app-serving-join-servers>

  <!-- Message Logs -->
  <app-message-logs
    virtId="{{ listInfo['virtId'] }}"
    [netIds]="listInfo['netIds']"
    [getLogsUrl]="logsUrl"
  >
  </app-message-logs>

  <!-- RF PARAMSET ELEMENTS -->
  <app-rf-paramsets
    virtId="{{ listInfo['virtId'] }}"
    [listRfParamSetElements]="listInfo['rfParamSets']"
  ></app-rf-paramsets>
</div>

<div *ngIf="!hasAcces">
  <h1>{{ errorStatus }}:{{ errorText }}</h1>
</div>
